export default __webpack_public_path__ + "static/media/instagram.4003c6b6.png";